import React from 'react';
import { PictoProps } from './index';

export const DislikeCircleFilled = (props: PictoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '30'}
    height={props.height || '30'}
    viewBox="0 0 30 30"
    fill="none"
  >
    <circle cx="15" cy="15" r="15" transform="rotate(-180 15 15)" fill="#EFEFEF" />
    <path
      d="M6.92306 16.063C6.92306 13.9384 7.6516 11.0975 7.98437 10.2167C8.13137 9.82431 8.37529 9.47754 8.69029 9.20565C8.98268 8.94842 9.35421 8.80352 9.74352 8.79538C10.5157 8.79538 11.1408 8.7791 11.7256 8.76445C13.8418 8.71072 15.4668 8.67002 17.4764 9.34241L17.4764 18.7477C17.3051 18.9626 17.1436 19.1856 16.9966 19.4168C16.3198 20.5011 15.8949 21.7238 15.7495 22.9969C15.6413 23.8256 15.3554 24.3042 14.9903 24.5029C14.6511 24.6868 14.2795 24.6396 13.9241 24.4035C13.5946 24.1642 13.3248 23.8516 13.1374 23.4886C12.5511 22.4352 12.2231 20.6883 12.8515 18.9121L8.58367 18.9121C8.4076 18.9121 8.23313 18.8828 8.06837 18.8209C7.61606 18.6484 7.32044 18.2593 7.14437 17.7301C6.98444 17.1896 6.91175 16.628 6.92629 16.063L6.92306 16.063ZM18.6604 19.1173L22.6828 19.1173C22.9008 19.1173 23.0769 18.9382 23.0769 18.7184L23.0769 8.85888C23.0769 8.63909 22.9008 8.46163 22.6828 8.46163L18.6604 8.46163C18.4424 8.46163 18.2663 8.63909 18.2663 8.85725L18.2663 18.7167C18.2663 18.9365 18.4424 19.114 18.6588 19.114L18.6604 19.1173Z"
      fill="#000000"
    />
  </svg>
);
